import axios from "axios";

import { auth } from "../../../components/firebase";

const API_BASE =
  import.meta?.env?.VITE_CF_BASE ||
  process.env.REACT_APP_CF_BASE ||
  ""; 

async function getIdTokenOrThrow() {
  const u = auth.currentUser;
  if (!u) throw new Error("Not authenticated");
  return await u.getIdToken();
}
export async function apiGetForwarderDepositAddress({ chainId, token }) {
  const idToken = await getIdTokenOrThrow();
  const url = `${API_BASE}/getForwarderDepositAddress`;
  const resp = await axios.post(url, { chainId, token }, {
    headers: { Authorization: `Bearer ${idToken}` },
    timeout: 20000,
  });
  return resp.data; // { ok, chainId, address, token, tokenKind, tokenAddress, decimals }
}
